import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./motion";

const faqs = [
  {
    q: "What's the difference between the booking fee and the deposit?",
    a: "The $25 booking fee is a non-refundable scheduling fee. The $50 deposit reserves your move date and is credited toward your final bill.",
  },
  {
    q: "When will I get my invoice?",
    a: "The same day your job is completed. It's itemized with start and stop times and every charge.",
  },
  {
    q: "What if something gets damaged?",
    a: "Report it in writing within 7 days with photos. Our liability is limited to $0.60 per pound per item unless otherwise agreed in writing. See our customer terms for details.",
  },
  {
    q: "Do you provide the truck?",
    a: "No. We provide labor only. You rent the truck, trailer, or container, and our crew handles the loading, unloading, and heavy lifting.",
  },
];

export const FAQ = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="relative z-10 bg-[#262626] py-20 sm:py-28 border-y border-white/5"
  >
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal className="mb-12">
        <p className="text-xs tracking-[0.3em] uppercase text-[#FF4500] font-bold mb-4">
          FAQ
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl">
          Common Questions
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="border-[#3d3d3d]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="text-left font-display font-bold text-base sm:text-lg text-white hover:text-[#FF4500] hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-300 leading-relaxed text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
